import { z } from 'zod';

/** The feed configuration the editor holds as text: a JSON object, or null when it is not one. */
export function parseFeedConfig(text: string): Record<string, unknown> | null {
  try {
    const value: unknown = JSON.parse(text);
    return value && typeof value === 'object' && !Array.isArray(value)
      ? (value as Record<string, unknown>)
      : null;
  } catch {
    return null;
  }
}

export const feedConfigSchema = z.object({
  config: z
    .string()
    .refine((text) => parseFeedConfig(text) !== null, 'Enter the configuration as a JSON object.'),
});

/** The body to save: the configuration without `_id`, which the service owns. */
export function feedConfigPayload(text: string): Record<string, unknown> {
  const { _id, ...rest } = parseFeedConfig(text) ?? {};
  return rest;
}
